// src/services/firebase.js
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { firebaseConfig } from '../config/environment';

// Firebase重複初期化を防ぐ
let app;
try {
    if (getApps().length === 0) {
        app = initializeApp(firebaseConfig);
    } else {
        app = getApps()[0];
    }
} catch (error) {
    console.error('Firebase初期化エラー:', error);
    throw error;
}

// Firebase認証サービスを初期化
export const auth = getAuth(app);

// Firestoreデータベースサービスを初期化
export const db = getFirestore(app);

// Firebase Storageサービスを初期化
export const storage = getStorage(app);